import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const masterPaymentList = createAsyncThunk('masterPaymentList', async ({ pageable: data, navigate, role_id }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'payment',
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(role_id ? { role_id } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const masterPaymentListSlice = createSlice({
    name: 'masterPaymentList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(masterPaymentList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => {
                    const raw = action.payload.data.data;
                    if (Array.isArray(raw?.getPaymentList)) return raw.getPaymentList;
                    return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []);
                })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(masterPaymentList.rejected, () => { })
    }
})

export default masterPaymentListSlice.reducer;
